<p
	class="obg-m-select-player-profile-description"
	[innerHtml]="'casino-block.select-player-profile.description' | jurisdiction | translate"
></p>
<mat-radio-group
	[(ngModel)]="playerProfile"
	(change)="playerProfileChange.emit(playerProfile)"
	[disabled]="radioGroupDisabled"
>
	<mat-radio-button color="primary" [value]="allProducts" *ngIf="isJurisdictionSga$ | async">
		<strong>{{ "casino-block.select-player-profile.radio.all-products.strong" | jurisdiction | translate }}</strong>
		<br />{{ "casino-block.select-player-profile.radio.all-products" | jurisdiction | translate }}
	</mat-radio-button>
	<mat-radio-button color="primary" [value]="sportsbookOnly">
		<strong>{{
			"casino-block.select-player-profile.radio.sportsbook-only.strong" | jurisdiction | translate
		}}</strong>
		<br />{{ "casino-block.select-player-profile.radio.sportsbook-only" | jurisdiction | translate }}
	</mat-radio-button>
</mat-radio-group>
<p
	*ngIf="playerProfile !== allProducts"
	class="obg-m-select-player-profile-note"
	[innerHtml]="'casino-block.select-player-profile.note' | jurisdiction | translate"
></p>
